"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectedPlan_1 = require("./SelectedPlan");
exports.default = SelectedPlan_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectedPlan/index.js
// module id = 1401
// module chunks = 8